// 定数の定義
const SESSION_KEY = 'petmomento_sessionID'; // プロジェクト名や用途に基づくユニークなキー
const SESSION_EXPIRY_DAYS = 30; // セッションの有効期限 (日数)

// セッションID生成関数 (UUID形式)
function generateSessionID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// セッションIDを作成または取得する関数
function getSessionID() {
    // 現在のセッションデータを取得
    const savedData = JSON.parse(localStorage.getItem(SESSION_KEY));

    if (savedData) {
        const { id, createdAt } = savedData;

        // 期限切れをチェック
        const expiryTime = SESSION_EXPIRY_DAYS * 24 * 60 * 60 * 1000; // ミリ秒に変換
        if (Date.now() - createdAt < expiryTime) {
            // 期限内の場合、既存のセッションIDを返す
            return id;
        }
    }

    // 新しいセッションIDを生成して保存
    const newSessionID = generateSessionID();
    saveSessionID(newSessionID);
    return newSessionID;
}

// セッションIDを保存する関数
function saveSessionID(sessionID) {
    const sessionData = {
        id: sessionID,
        createdAt: Date.now() // 現在時刻を保存
    };
    localStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
}

// セッションIDを取得または生成
window.sessionId  = getSessionID();

// コンソールにセッションIDを表示
console.log('Session ID:', window.sessionId);